export default __webpack_public_path__ + "static/media/ddf-film-lanyard.6b8d8002.png";